<template>
  <md-card>
    <div class="card">
      <div class="action-bar">

        <md-switch
            v-model="guidance.allow_manual"
            class="md-primary mb-0"
            @change="saveAllowManual"
            :disabled="isLoading"
            :title="guidance.allow_manual ? 'Disable Manual Entry' : 'Enable Manual Entry'"
        >
          <md-icon>
            {{ guidance.allow_manual ? 'edit_note' : 'block' }}
          </md-icon>
          {{guidance.allow_manual ? 'Enabled Manual Entry' : ' Disabled Manual Entry'}}
        </md-switch>

        <md-button
            class="md-dense md-raised md-secondary"
            @click="goBack"
        >
          <md-icon>arrow_back</md-icon>
          Go Back
        </md-button>

      </div>
      <md-card-header>
        <items-view :title="'Guidance Details: ' + guidance.name">
          <item-view label="Guidance Number" :value="guidance.guidance_number"></item-view>
          <item-view label="Guidance Duration" :value="guidance.duration"></item-view>
          <item-view label="Guidance Type" :value="guidance.guidance_type"></item-view>
          <item-view label="Guidance Date" :value="guidance.date_range"></item-view>
          <item-view label="Port" :value="getPortName()"></item-view>
          <item-view label="Department" :value="getDepartmentName()"></item-view>
          <item-view label="Vendor" :value="getVendorName()"></item-view>
          <item-view label="Tariff" :value="getTariffName()"></item-view>
          <item-view label="Status">
            <span :class="`status-badge status-${state}`">{{ guidance.status }} </span>
          </item-view>
          <item-view label="Total Value" :value="formatCurrency(overallWorkItemsTotal())"></item-view>
          <item-view :label="'Total '+ payUnit()" :value="formatNumber(overallWorkItemsQty())"></item-view>

        </items-view>
        <hr />
        <items-view
            title="Per Work Done Form"
            class="form-details-card"
            v-if="guidance.status===''"
        >
          <item-view label="Workplace">
            <!-- Workplace -->
            <select-input
                v-model="workItem.workplace_id"
                :options="allWorkplaces"
                :error="apiValidationErrors.workplace_id"
                track-by="id"
                name="name"
                placeholder="Select Workplace"
            />
          </item-view>
          <item-view label="Activity" v-if="canShowActivity">
            <!-- Activity -->
              <select-input
                  v-model="workItem.activity_id"
                  :options="activities"
                  :error="apiValidationErrors.activity_id"
                  track-by="id"
                  name="name"
                  placeholder="Select Activity"
              />
          </item-view>
          <item-view label="Shift"  v-if="canShowShift">
            <select-input
                v-model="detailForm.shift_id"
                :options="shifts"
                track-by="id"
                name="name"
                placeholder="Select Shift"
            />
          </item-view>

          <item-view :label="!isManualActivity ? 'Master Ticket Number' : 'Item Number'"
                     v-if="canShowItemNumber">

              <md-field>
                <md-input v-model="detailForm.item_number"
                          style="background: #fff;"
                          :placeholder="!isManualActivity ?'Enter Master Ticket Number':'Enter Item Number'"
                />
              </md-field>
          </item-view>
          <template
              v-if="isManualActivity"
          >

            <item-view label="Commodity"  v-if="canShowCommodity">
              <md-field>
                <md-input
                    v-model.trim="detailForm.commodity"
                    style="background: #fff;"
                    placeholder="Enter Commodity"
                />
              </md-field>
            </item-view>
            <item-view label="Category"  v-if="canShowCategory">
              <select-input
                  v-model="detailForm.category"
                  :options="itemCategories"
                  :error="apiValidationErrors.category"
                  track-by="id"
                  name="name"
                  placeholder="Select Cargo type"
              />
            </item-view>

            <item-view label="Vessel"  v-if="canShowVessel">
<!--              <select-input-->
<!--                  v-model="selectedVessel"-->
<!--                  :options="vessels"-->
<!--                  track-by="id"-->
<!--                  name="name"-->
<!--                  placeholder="Select vessel"-->
<!--              />-->

                <div class="vessel-select-wrapper">

                  <div class="vessel-select">
                    <select-input
                        v-model="selectedVessel"
                        :options="vessels"
                        track-by="id"
                        name="name"
                        placeholder="Select vessel"
                    />
                  </div>

                  <md-button
                      class="md-icon-button md-primary md-raised md-dense add-vessel-btn"
                      @click="showAddVessel = true"
                      title="Add Vessel"
                  >
                    <md-icon>add</md-icon>
                  </md-button>

                </div>

            </item-view>

            <item-view label="Call ID"  v-if="canShowCallId">
              <md-field>
                <md-input
                    v-model.trim="detailForm.call_id"
                    style="background: #fff;"
                    placeholder="Enter Call ID"
                />
              </md-field>
            </item-view>

            <item-view :label="quantityUnit"  v-if="canShowQuantity">
              <md-field>
                <md-input
                    v-model.number="detailForm.quantity"
                    type="number"
                    min="1"
                    style="background: #fff;"
                    :placeholder="'Enter ' + quantityUnit"
                />
              </md-field>
            </item-view>
            <item-view :label="'Unit'"  v-if="canShowQuantity">

                  <md-radio v-if="quantityUnit==='Tonnage'"
                      v-model="detailForm.unit"
                      value="kg"
                  >
                    Kg
                  </md-radio>
              <md-radio v-if="quantityUnit==='Tonnage'"
                      v-model="detailForm.unit"
                      value="t"
                  >
                    Tonnes
                  </md-radio>
              <md-radio v-if="quantityUnit==='TEUs'"
                      v-model="detailForm.unit"
                      value="TEUs"
                  >
                    TEUs
                  </md-radio>
              <md-radio v-if="quantityUnit==='Quantity'"
                      v-model="detailForm.unit"
                      value="Qty"
                  >
                    Quantity
                  </md-radio>

            </item-view>

            <item-view label="Date" v-if="canShowDate">
              <small class="form-hint">
                ( Allowed range:
                {{ guidance.start_date }} - {{ guidance.end_date }})
              </small>
              <md-field :class="{ 'md-invalid': apiValidationErrors.date }">

                <md-datepicker
                    v-model="detailForm.date"
                    md-immediately
                    :md-disabled-dates="disabledDates"
                >
                  <label>Select Date</label>
                </md-datepicker>


              </md-field>
              <span class="md-error" v-if="apiValidationErrors.date">
          {{ apiValidationErrors.date }}
        </span>

            </item-view>

       </template>



          <item-view label="Action"
                     v-if="canShowAction">
            <md-button
                class="md-raised md-primary"
                :disabled="previewLoading || isLoading"
                @click="previewTicket"
            >
              <md-icon>visibility</md-icon>
    <span
        v-if="previewLoading"
        class="spinner-border spinner-border-sm mr-1"
    ></span>

              {{ previewLoading ? 'Checking...' : 'Preview' }}
            </md-button>

          </item-view>
          </items-view>

        <!-- Two Column Layout for Dashboard -->
        <div class="md-layout">
          <!-- Left Column: Statistics -->
          <div
              class="md-layout-item
         md-size-80
         md-medium-size-90
         md-small-size-100
         md-xsmall-size-100"
          >

            <!--        Start new design-->
            <div class="works-container">

              <div
                  v-for="work in works"
                  :key="work.id"
                  class="work-card"
              >

                <!-- WORK HEADER -->
                <div class="work-header">

                  <div>
                    <div class="work-title">
                    <span class="work-number">
                        {{ work.name  }}
                    </span>
                    </div>

                    <div class="work-information">

                    <span class="vessel-badge">
                        <md-icon>directions_boat</md-icon>
                        <strong>Vessel:</strong>
                        <span > {{ work.vessel?work.vessel.name : '-' }}</span>
                    </span>

                      <span v-if="work.date">
                        <md-icon>event</md-icon>
                        <strong>Date:</strong>
                        {{ work.date }}
                    </span>

                      <span>
                        <md-icon>list_alt</md-icon>
                        <strong>Items:</strong>
                        {{ work.items.length || 0 }}
                    </span>
                      <span>
        <md-icon>confirmation_number</md-icon>
        <strong>Call ID:</strong>
        {{ work.call_id || '-' }}
        </span>
                      <span>
                        <template v-if="guidance.pay_code==='PT'">
                          <md-icon>scale</md-icon>
                        </template>
                        <template v-else>
                          <md-icon>format_list_numbered</md-icon>
                        </template>

        <strong>{{payUnit()}}:</strong>
        {{ formatNumber(workQty(work))}}
        </span>
                      <span>
        <md-icon>money</md-icon>
        <strong>TOTAL:</strong>
        {{ formatCurrency(workTotal(work))}}
        </span>

                    </div>
                  </div>

                </div>


                <!-- ITEMS TABLE -->
                <div class="table-responsive">

                  <table class="table table-hover items-table">

                    <thead>
                    <tr>
                      <th width="40"></th>
                      <th>Item</th>
                      <th>Activity</th>
                      <th>Workplace</th>
                      <th>Unit</th>
                      <th>Quantity</th>
                      <th>Amount</th>
                      <th>Sub Items</th>
                    </tr>
                    </thead>

                    <tbody>

                    <template v-for="item in work.items">

                      <!-- ITEM -->
                      <tr
                          :key="item.id"
                          class="item-row"
                          @click="toggleItem(item.id)"
                      >

                        <td>
                          <md-icon>
                            {{
                              expandedItems.includes(item.id)
                                  ? 'expand_less'
                                  : 'expand_more'
                            }}
                          </md-icon>
                        </td>

                        <td>
                          <strong>
                            {{ item.name || '-' }}
                          </strong>
                        </td>

                        <td>
                          {{ item.activity?item.activity.name : '-' }}
                        </td>

                        <td>
                          {{ item.workplace?item.workplace.name : '-' }}
                        </td>

                        <td>
                          {{payUnit() }}
                        </td>
                        <td>
                          {{ formatNumber(workItemQty(item))}}
                        </td>
                        <td>
                          <strong>
                            {{formatCurrency(workItemTotal(item))}}
                          </strong>
                        </td>
                        <td>
                          <strong>
                            {{formatNumber(totalSubItems(item))}}
                          </strong>
                        </td>

                      </tr>


                      <!-- WORK DETAILS -->
                      <tr
                          v-if="expandedItems.includes(item.id)"
                          :key="item.id + '-details'"
                          class="details-row"
                      >

                        <td colspan="8">

                          <div class="details-container">

                            <div class="details-title">
                              <md-icon>list_alt</md-icon>
                              Work Details
                            </div>

                            <table
                                v-if="item.workDetails.length"
                                class="table table-sm details-table"
                            >

                              <thead>
                              <tr>
                                <th>#</th>
                                <th>Item Number</th>
                                <th>Date</th>
                                <th>Commodity</th>
                                <th>Shift</th>
                                <th>{{payUnit()}}</th>
                                <th>Amount</th>
                                <th>Remarks</th>
                              </tr>
                              </thead>

                              <tbody>

                              <tr
                                  v-for="(detail, index) in item.workDetails"
                                  :key="detail.id"
                              >
                                <td>{{ index + 1 }}</td>

                                <td>
                                  {{ detail.item_number || '-' }}
                                </td>
                                <td>
                                  {{ detail.date || '-' }}
                                </td>
                                <td>
                                  {{ detail.commodity || '-' }}
                                </td>

                                <td>
                                  {{ detail.shift?detail.shift.name : '-' }}
                                </td>

                                <td>
                                  {{ workDetailQty(detail) || 0 }}
                                </td>
                                <td>{{formatCurrency(lineTotal(detail,item)) }}</td>

                                <td>
                                  {{ detail.remarks || '-' }}
                                </td>
                              </tr>

                              </tbody>

                            </table>

                            <div
                                v-else
                                class="text-muted"
                            >
                              No work details available.
                            </div>

                          </div>

                        </td>

                      </tr>

                    </template>

                    </tbody>

                  </table>

                </div>

              </div>

            </div>

            <!--        End New design-->

          </div>
          <!-- Right Column: Status Timeline -->
          <div
              class="md-layout-item
         md-size-20
         md-medium-size-10
         md-small-size-100
         md-xsmall-size-100"
          >
            <!-- Status Progress -->
            <md-card class="status-card">
              <md-card-header>
                <div class="card-header-title">
                  <md-icon>timeline</md-icon>
                  <span>Status Progress</span>
                </div>
              </md-card-header>
              <md-card-content>
                <div class="status-progress">
                  <div v-for="step in statusSteps" :key="step.name" class="progress-step"
                       :class="getProgressStepClass(step.name)">
                    <div class="step-marker">
                      <md-icon v-if="isStatusCompleted(step.name)">check_circle</md-icon>
                      <md-icon v-else-if="guidance.status === step.name">radio_button_checked</md-icon>
                      <md-icon v-else>radio_button_unchecked</md-icon>
                    </div>
                    <div class="step-content">
                      <div class="step-name">{{ step.name }}</div>
                      <div class="step-date" v-if="getStatusDate(step.name)">
                        {{ formatDateShort(getStatusDate(step.name)) }}
                      </div>
                    </div>
                  </div>
                </div>
              </md-card-content>
            </md-card>
            <!-- Action Buttons -->
            <md-card class="actions-card">
              <md-card-header>
                <div class="card-header-title">
                  <md-icon>build</md-icon>
                  <span>Actions</span>
                </div>
              </md-card-header>
              <md-card-content>
                <div class="action-buttons-vertical">

                  <md-button
                      v-for="status in visibleStatusButtons"
                      :key="status.id"
                      :class="[
                            'md-raised',
                            'action-workflow-btn',
                            `action-${status.action.toLowerCase()}`
                          ]"
                      @click="showStatusModal(status)"
                  >
                    <md-icon>check_circle</md-icon>
                    {{ status.action }}
                  </md-button>

                  <md-button
                      v-if="canReject()"
                      class="md-raised action-workflow-btn action-reject"
                      @click="showRejectModal"
                  >
                    <md-icon>cancel</md-icon>
                    Reject
                  </md-button>

                  <md-button
                      v-if="guidance.status==='' && guidance.works.length > 0"
                      class="md-raised action-workflow-btn action-page"
                      @click="actionPage"
                  >
                    <md-icon>settings</md-icon>
                    Action Page
                  </md-button>

                </div>
              </md-card-content>

            </md-card>

            <!-- Status History -->
            <md-card class="history-card">
              <md-card-header>
                <div class="card-header-title">
                  <md-icon>history</md-icon>
                  <span>Status History</span>
                </div>
              </md-card-header>
              <md-card-content>
                <div class="status-history" v-if="canListStatus()">
                  <div v-for="statusItem in guidance.statuses_with_trashed" :key="statusItem.id"
                       class="history-item">
                    <div class="history-badge"
                         :class="statusItem.deleted_at === null ? 'badge-info' : 'badge-danger'">
                      {{ statusItem.name }}
                    </div>
                    <div class="history-details">
                      <div class="history-reason">{{ statusItem.reason || 'No reason provided' }}</div>
                      <div class="history-meta">
                        <span v-html="creatorLabel(statusItem)"></span>
                        <span class="history-date">{{ formatDateTime(statusItem.created_at) }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="no-history">
                  <md-icon>info</md-icon>
                  <p>No status history available</p>
                </div>
              </md-card-content>
            </md-card>
          </div>
        </div>

      </md-card-header>

      <!-- Action Buttons -->
      <div class="action-bar">
        <md-button class="md-dense md-raised md-secondary" @click="goBack">
          <md-icon>arrow_back</md-icon> Go Back
        </md-button>
      </div>
    </div>
    <!-- Status Change Modal -->
    <modal v-if="modal.classicModal" @close="classicModalHide">
      <template slot="header">
        <h4 class="modal-title">Change Status to {{ getSelectedAction() }}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="classicModalHide">
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <div slot="body">
        <div v-if="reject">
          <p>Please provide reason(s) for rejection</p>
          <form @submit.prevent="updateStatus">
            <md-field>
              <md-input v-model="status.reason" placeholder="Reasons for Rejection"/>
              <validation-error :errors="apiValidationErrors.reason"/>
            </md-field>
            <md-button type="submit" class="md-danger md-dense">Reject</md-button>
          </form>
        </div>
        <div v-else>
          <p class="font-weight-bold">Ensure that the Guidance is correct then state reason for {{
              getSelectedAction()
            }}</p>
          <form @submit.prevent="updateStatus">
            <md-field>
              <md-input v-model="status.reason" placeholder="Reason (Optional)"/>
              <validation-error :errors="apiValidationErrors.reason"/>
            </md-field>
            <md-button type="submit" class="md-primary md-dense">
              {{ getSelectedAction() }}
            </md-button>
          </form>
        </div>
      </div>

      <template slot="footer">
        <md-button class="md-danger md-simple" @click="classicModalHide">Close</md-button>
      </template>
    </modal>
    <md-dialog
        :md-active.sync="showTicketPreview"
        :md-click-outside-to-close="false"
        :md-close-on-esc="true"
        class="ticket-preview-dialog"
    >
      <md-dialog-title>
        <div class="d-flex justify-content-between align-items-center">
            <span>
                <md-icon>description</md-icon>
                Data Preview
            </span>
        </div>
      </md-dialog-title>

      <md-dialog-content v-if="ticketPreview">

        <div class="ticket-preview">

          <!-- Ticket Information -->
          <div class="preview-section">
            <p class="text-muted mb-3">
              Please review the information below. If everything is correct,
              click <strong>Save</strong> to continue.
            </p>
            <div class="preview-section-title">
              <i class="fas fa-ticket-alt"></i>
              Item Information
            </div>

            <div class="md-layout">

              <div class="md-layout-item md-size-25 preview-field">
                <small class="text-muted">
                  Ticket/Item Number
                </small>
                <div class="preview-value">
                  {{ ticketPreview.ticket.item_number }}
                </div>
              </div>

              <div class="md-layout-item md-size-25 preview-field">
                <small class="text-muted">
                  Commodity
                </small>
                <div class="preview-value">
                  {{ ticketPreview.ticket.commodity }}
                </div>
              </div>

              <div class="md-layout-item md-size-25 preview-field">
                <small class="text-muted">
                  Category
                </small>
                <div class="preview-value">
                  {{ ticketPreview.ticket.operation_category }}
                </div>
              </div>

              <div class="md-layout-item md-size-25 preview-field">
                <small class="text-muted">
                  Vessel
                </small>
                <div class="preview-value">
                  {{ ticketPreview.ticket.vessel_name }}
                </div>
              </div>

            </div>

            <div class="md-layout">

              <div class="md-layout-item md-size-25 preview-field">
                <small class="text-muted">
                  Call ID
                </small>
                <div class="preview-value">
                  {{ ticketPreview.ticket.call_id }}
                </div>
              </div>

              <div class="md-layout-item md-size-25 preview-field">
                <small class="text-muted">
                  Date
                </small>
                <div class="preview-value">
                  {{ ticketPreview.ticket.date }}
                </div>
              </div>
              <div class="md-layout-item md-size-25 preview-field">
                <small class="text-muted">
                  Data Source
                </small>
                <div class="preview-value">
                  {{ ticketPreview.ticket.source }}
                </div>
              </div>

            </div>

          </div>


          <!-- Weight Information -->
          <div class="preview-section">

            <div class="preview-section-title">
              <i class="fas fa-weight-hanging"></i>
              Quantity Information
            </div>

            <div class="md-layout">

              <div class="md-layout-item md-size-25 preview-field">
                <small class="text-muted">
                  Gross Weight
                </small>
                <div class="preview-value">
                  {{ ticketPreview.ticket.gross_weight }} kg
                </div>
              </div>

              <div class="md-layout-item md-size-25 preview-field">
                <small class="text-muted">
                  Tare Weight
                </small>
                <div class="preview-value">
                  {{ ticketPreview.ticket.tare_weight }} kg
                </div>
              </div>

              <div class="md-layout-item md-size-25 preview-field">
                <small class="text-muted">
                  Net Weight
                </small>
                <div class="preview-value">
                  {{ ticketPreview.ticket.net_weight }} kg
                </div>
              </div>

              <div class="md-layout-item md-size-25 preview-field">
                <small class="text-muted">
                  {{ ticketPreview.ticket.unit }}
                </small>
                <div class="preview-value font-weight-bold">
                  {{ ticketPreview.ticket.quantity }}
                </div>
              </div>

            </div>

          </div>


          <!-- Assignment Information -->
          <div class="preview-section">

            <div class="preview-section-title">
              <i class="fas fa-tasks"></i>
              Base Data Information
            </div>

            <div class="md-layout">

              <div class="md-layout-item md-size-25 preview-field">
                <small class="text-muted">
                  Guidance
                </small>
                <div class="preview-value">
                  {{ ticketPreview.guidance.name }}
                </div>
              </div>

              <div class="md-layout-item md-size-25 preview-field">
                <small class="text-muted">
                  Activity
                </small>
                <div class="preview-value">
                  {{ ticketPreview.activity.name }}
                </div>
              </div>

              <div class="md-layout-item md-size-25 preview-field">
                <small class="text-muted">
                  Workplace
                </small>
                <div class="preview-value">
                  {{ ticketPreview.workplace.name }}
                </div>
              </div>

              <div class="md-layout-item md-size-25 preview-field">
                <small class="text-muted">
                  Shift
                </small>
                <div class="preview-value">
                  {{ ticketPreview.shift.name }}
                </div>
              </div>

            </div>

          </div>


          <!-- Already Imported -->
          <div
              v-if="ticketPreview.already_imported"
              class="alert alert-warning mt-3"
          >
            <i class="fa fa-exclamation-triangle mr-2"></i>

            <strong>Already Added</strong>

            <div>
              This ticket has already been added.
            </div>
          </div>

        </div>

      </md-dialog-content>


      <!-- Footer -->
      <md-dialog-actions v-if="ticketPreview">

        <md-button
            class="md-raised"
            @click="cancelTicket"
        >
          Cancel
        </md-button>

        <md-button
            class="md-raised md-primary"
            :disabled="isLoading || !ticketPreview.can_import"
            @click="saveTicket"
        >
          <md-icon>save</md-icon>
          Save
        </md-button>

      </md-dialog-actions>

    </md-dialog>
    <md-dialog :md-active.sync="showAddVessel">

      <md-dialog-title>
        <md-icon>directions_boat</md-icon>
        Add Vessel
      </md-dialog-title>

      <md-dialog-content>

        <md-field>
          <label>Vessel Name</label>

          <md-input
              v-model="newVessel.name"
              autofocus
          />
        </md-field>

        <md-field>
          <label>IMO Number</label>

          <md-input
              v-model="newVessel.imo_number"
              maxlength="7"
          />
        </md-field>

      </md-dialog-content>

      <md-dialog-actions>

        <md-button
            @click="showAddVessel = false"
        >
          Cancel
        </md-button>

        <md-button
            class="md-primary md-raised"
            :disabled="
                !newVessel.name.trim() ||
                !newVessel.imo_number.trim() ||
                isLoading
            "
            @click="addVessel"
        >
          <md-icon>save</md-icon>
          Save
        </md-button>

      </md-dialog-actions>

    </md-dialog>
  </md-card>
</template>

<script>
// import { ValidationError } from '@/components';
import guidanceStatisticsMixin from '@/mixins/guidance-statistics-mixin';
import formMixin from '@/mixins/form-mixin';
import Swal from 'sweetalert2';
import ItemsView from '../../../../components/Inputs/ItemsView';
import ItemView from '../../../../components/Inputs/ItemView';
import SelectInput from '@/components/Inputs/SelectInput.vue';
import {Modal, ValidationError} from "@/components";
import Vuex from "vuex";
import Multiselect from "vue-multiselect";
import 'vue-multiselect/dist/vue-multiselect.min.css'
// import GuidanceStatisticPanel from "@/pages/settings/guidances/components/GuidanceStatisticPanel.vue";

export default {
  name: 'ManageGuidanceShiftPage',
  components: {
    SelectInput,
    Multiselect,
    ValidationError, Modal,
    ItemView,
    ItemsView,
    // GuidanceStatisticPanel
  },
  mixins: [formMixin,guidanceStatisticsMixin],
  data() {
    return {
      state:'',
      expandedItems: [],
      showTicketPreview: false,
      showCategorySelect: false,
      modal: {
        classicModal: false,
      },
      roles: [],
      allPermissions: [],
      status: {
        name: null,
        reason: null,
      },
      ticketPreview: null,
      previewLoading: false,
      reject: false,
      selectedStatus: null,
      expandedWorkItems: {},
      activeTariff: {},
      selected_shifts: [],
      backup_shifts: [],
      activities:[],
      allWorkplaces: [],
      editableWorkPoint: '',
      shifts: [],
      vessels: [],
      workPoints: [],
      workPoint:null,
      showWorkForm: false,
      showWorkModal: false,
      showAddVessel: false,

      newVessel: {
        name: '',
        imo_number: ''
      },
      workMode: 'create',
      work: {
        id: null,
        guidance_id: null,
        name: '',
        call_id: '',
        vessel_id: null
      },
      selectedVessel: null,
      workItem:{
        name:null,
        activity_id:null,
        workplace_id:null,
        date:null,
      },
      showWorkItemModal: false,

      workItemDetails: {},
      showForms: {},
      editMode: {},
      editingDetail: {},
      itemTypes: [
        'Containerized Cargo',
        'Dry Bulk Cargo',
       'Break Bulk Cargo',
        'Liquid Bulk Cargo',
        'General Cargo',
       'Bagged Cargo',
        'Ro-Ro Cargo',
        'Hazardous Cargo',
        'Livestock',
        'Oversized Cargo',
        'Lo-Lo Cargo',
      ],
      itemCategories: [
        { id: 1, name: 'Containerized Cargo' },
        { id: 2, name: 'Dry Bulk Cargo' },
        { id: 3, name: 'Break Bulk Cargo' },
        { id: 4, name: 'Liquid Bulk Cargo' },
        { id: 5, name: 'General Cargo' },
        { id: 6, name: 'Bagged Cargo' },
        { id: 7, name: 'Ro-Ro Cargo' },
        { id: 8, name: 'Hazardous Cargo' },
        { id: 9, name: 'Livestock' },
        { id: 10, name: 'Oversized Cargo' },
        { id: 11, name: 'Lo-Lo Cargo' },
      ],
      payload:{},

      guidance: {
        id: null,
        name: null,
        guidance_number: null,
        duration: null,
        date_range: null,
        port: null,
        department: null,
        vendor: null,
        tariff: null,
        status: null,
	 possibles: [],
        statuses: [],
        statuses_with_trashed: [],
      },
      id: '',
      isLoading: false,
      exceptionSaving: false,
      visibleExceptions: {},
      showDetailModal: false,
      modalMode: 'create', // create | edit
      selectedWorkItem: null,
      workItemMode:'create',
      detailForm: {
        id: null,
        item_number: '',
        date: null,
        shift_id: null,
        commodity: '',
        item_type: '',
        category: null,
        quantity: null,
        remarks: '',
        unit: null
      },
      holidays:[],


    };
  },
  watch: {
    'guidance.status': {
      immediate: true,

      handler(newStatus) {
        if (newStatus === 'Accepted') {
          this.state = 'accepted'
        } else if (newStatus === 'Approved') {
          this.state = 'success'
        }else if (newStatus === 'Confirmed') {
          this.state = 'warning'
        }else if (newStatus === 'Certified') {
          this.state = 'info'
        }else if (newStatus === 'Reviewed') {
          this.state = 'purple'
        }else if (newStatus === 'Created') {
          this.state = 'primary'
        }else{
          this.state = 'default'
        }
      }
    },
    selectedVessel(vessel) {
      this.work.vessel_id = vessel ? vessel.id : null;
    },

    'workItem.workplace_id'(workplaceId) {
      const workplace = this.allWorkplaces.find(
          w => w.id == workplaceId
      );

      this.activities = workplace
          ? workplace.activities
          : [];
    },
    'guidance.workItems': {
      immediate: true,
      handler: function (items) {
        if (!items) return;

        items.forEach(item => {
          this.$set(this.workItemDetails, item.id, {
            item_number: '',
            date: null,
            shift_id: null,
            commodity: '',
            item_type: '',
            quantity: null,
            remarks: ''
          });
        });
      }
    },
    me: {
      handler: function (val) {

        if (!val) {
          return;
        }

        if (Array.isArray(val.roles)) {
          this.roles = val.roles.map(function (r) {
            return r.name;
          });
        }

        if (Array.isArray(val.allPermissions)) {
          this.allPermissions = val.allPermissions.map(function (p) {
            return p.name;
          });
        }
      },

      deep: true,
      immediate: true
    }
  },
  computed: {
    works() {
      return this.guidance && this.guidance.works
          ? this.guidance.works
          : [];
    },
    canShowActivity() {
      return !!this.workItem.workplace_id;
    },

    canShowShift() {
      return !!(
          this.workItem.workplace_id &&
          this.workItem.activity_id
      );
    },

    canShowItemNumber() {
      return !!(
          this.workItem.workplace_id &&
          this.workItem.activity_id &&
          this.detailForm.shift_id
      );
    },

    canShowCommodity() {
      return !!(
          this.canShowItemNumber &&
          this.detailForm.item_number
      );
    },

    canShowCategory() {
      return !!(
          this.canShowCommodity &&
          this.detailForm.commodity
      );
    },

    canShowVessel() {
      return !!(
          this.canShowCategory
      );
    },

    // Call ID is optional
    canShowCallId() {
      return !!this.selectedVessel;
    },

    // Quantity does NOT depend on call_id
    canShowQuantity() {
      return !!this.selectedVessel;
    },

    canShowDate() {
      return !!(
          this.selectedVessel &&
          this.detailForm.quantity
      );
    },

    canShowAction() {
      if (
          this.guidance.status !== ''
      ) {
        return false;
      }

      // Non-manual activity
      if (!this.isManualActivity) {
        return !!(
            this.workItem.workplace_id &&
            this.workItem.activity_id &&
            this.detailForm.shift_id &&
            this.detailForm.item_number
        );
      }

      // Manual activity
      return !!(
          this.workItem.workplace_id &&
          this.workItem.activity_id &&
          this.detailForm.shift_id &&
          this.detailForm.item_number &&
          this.detailForm.commodity &&
          this.detailForm.category &&
          this.selectedVessel &&
          this.detailForm.quantity &&
          this.detailForm.date
      );
    },
    selectedActivity() {
      return this.activities.find(
          activity => activity.id === this.workItem.activity_id
      ) || null;
    },


    isManualActivity() {
      return this.guidance?this.guidance.allow_manual:null;
    },

    quantityUnit() {
      if (!this.selectedActivity) {
        return 'Number';
      }

      switch (this.selectedActivity.pay_code) {
        case 'PU':
          return 'Quantity';

        case 'TU':
          return 'TEUs';
        case 'PT':
          return 'Tonnage';

        default:
          return 'Number';
      }
    },
    ...Vuex.mapState({
      me: state => state.profile.me
    }),
    statusSteps: function () {
      return [
        {name: 'Created', order: 1},
        {name: 'Reviewed', order: 2},
        {name: 'Certified', order: 3},
        {name: 'Confirmed', order: 4},
        {name: 'Approved', order: 5},
        {name: 'Accepted', order: 6}
      ];
    },
    visibleStatusButtons: function () {
      console.log(this.guidance.possibles);
      var self = this;
      var possibles = this.guidance.possibles || [];
      var visible = [];
      let works=this.guidance.works || [];

      possibles.forEach(function (status, index) {
        if (self.canShowStatusButton(status, index) && works.length > 0) {
          visible.push(status);
        }
      });

      return visible;
    },

  },

  created: function() {
    this.initialize();
    this.publicHolidays();
  },

  methods: {
    async addVessel() {

      const name = this.newVessel.name.trim();
      const imoNumber = this.newVessel.imo_number.trim();

      if (!name || !imoNumber) {
        return;
      }

      try {
        this.isLoading = true;

        const response = await this.$store.dispatch(
            'vessels/add',
            {
              type: 'vessels',
              name: name,
              imo_number: imoNumber
            }
        );
        console.log('Create Vessel Response:', response);
        const vessel = response.data || response;

        // Add newly created vessel to dropdown
        this.vessels.push(vessel);

        // Select newly created vessel
        this.selectedVessel = vessel.id;

        // Close dialog
        this.showAddVessel = false;

        // Reset
        this.newVessel = {
          name: '',
          imo_number: ''
        };

        await this.$store.dispatch(
            'alerts/success',
            'Vessel added successfully.'
        );

      } catch (e) {
this.notifyException(e)
        console.error('Create Vessel Error:', e);

      } finally {
        this.isLoading = false;
      }
    },

    toggleItem(itemId) {
      const index = this.expandedItems.indexOf(itemId);

      if (index === -1) {
        this.expandedItems.push(itemId);
      } else {
        this.expandedItems.splice(index, 1);
      }
    },


    //===========================
    formatDateTime: function (dateString) {
      if (!dateString) return '';
      return new Date(dateString).toLocaleString();
    },

    async saveTicket() {

      this.isLoading = true;

      try {
        const response = await this.$store.dispatch(
            'workItems/saveTicket',
           this.payload
        );

        await this.$store.dispatch(
            'alerts/success',
            response.message || 'Data Saved successfully.'
        );

        // Refresh guidance/work items if required
        await this.getGuidance();

        // Clear preview
        this.ticketPreview = null;

        // Reset form
        this.payload={};

        this.detailForm.item_number = '';
        this.workItem.workplace_id = null;
        this.workItem.activity_id = null;
        this.detailForm.shift_id = null;

        this.detailForm.commodity = '';
        this.detailForm.category = null;
        this.detailForm.call_id = '';
        this.detailForm.quantity = null;
        this.detailForm.date = null;
        this.detailForm.unit = null;
        this.selectedVessel = null;

        return response;
      } catch (e) {
       this.notifyException(e)
      } finally {
        this.isLoading = false;
        this.showTicketPreview= false;
      }
    },
    async previewTicket() {
      // Common fields
      if (!this.workItem.workplace_id) {
        return this.$store.dispatch(
            'alerts/error',
            'Please select a workplace.'
        );
      }

      if (!this.workItem.activity_id) {
        return this.$store.dispatch(
            'alerts/error',
            'Please select an activity.'
        );
      }

      if (!this.detailForm.shift_id) {
        return this.$store.dispatch(
            'alerts/error',
            'Please select a shift.'
        );
      }

      if (!this.detailForm.item_number) {
        return this.$store.dispatch(
            'alerts/error',
            'Please enter the master ticket/item number.'
        );
      }

      // Additional validation for manual activity
      if (this.isManualActivity) {

        if (!this.detailForm.commodity) {
          return this.$store.dispatch(
              'alerts/error',
              'Please enter commodity.'
          );
        }

        if (!this.detailForm.category) {
          return this.$store.dispatch(
              'alerts/error',
              'Please select a cargo category.'
          );
        }

        if (!this.detailForm.unit) {
          return this.$store.dispatch(
              'alerts/error',
              'Please select a Unit.'
          );
        }

        // Vessel is mandatory
        if (!this.selectedVessel) {
          return this.$store.dispatch(
              'alerts/error',
              'Please select a vessel.'
          );
        }

        // call_id is intentionally NOT validated because it is nullable

        if (
            !this.detailForm.quantity ||
            Number(this.detailForm.quantity) <= 0
        ) {
          return this.$store.dispatch(
              'alerts/error',
              `Please enter ${this.quantityUnit}.`
          );
        }

        if (!this.detailForm.date) {
          return this.$store.dispatch(
              'alerts/error',
              'Please select a date.'
          );
        }
      }

      this.previewLoading = true;
      this.ticketPreview = null;

      try {
        const payload = {
          guidance_id: this.guidance.id,
          workplace_id: this.workItem.workplace_id,
          activity_id: this.workItem.activity_id,
          shift_id: this.detailForm.shift_id,
          item_number: this.detailForm.item_number.trim(),
          unit: this.detailForm.unit,
        };

        // Add manual fields only for manual activity
        if (this.isManualActivity) {
          const selectedCategory = this.itemCategories.find(
              item => item.id === this.detailForm.category
          );
          const formatDate = date => {
            if (!date) return null;

            const d = new Date(date);

            return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
          };

          payload.commodity = this.detailForm.commodity.trim();
          payload.category = selectedCategory ? selectedCategory.name : null;
          payload.vessel_id = this.selectedVessel;
          payload.call_id = this.detailForm.call_id
              ? this.detailForm.call_id.trim()
              : null;
          payload.quantity = this.detailForm.quantity;
          payload.date = formatDate(this.detailForm.date);
        }

        const response = await this.$store.dispatch(
            'workItems/previewTicket',
            payload
        );

        this.ticketPreview = response.data;
        this.showTicketPreview = true;
        this.payload=payload;

        return response;

      } catch (e) {
        const message =
            e.response?.data?.errors?.[0]?.detail ||
            e.response?.data?.message ||
            'Unable to preview ticket. Please try again.';

        await this.$store.dispatch(
            'alerts/error',
            message
        );

        throw e;

      } finally {
        this.previewLoading = false;
      }

    },
    async cancelTicket() {
      this.previewLoading = false;
      this.ticketPreview = null;
      this.showTicketPreview= false,
      await this.$store.dispatch(
          'alerts/danger',
          "Preview Cancelled"
      );
    },

    disabledDates(date) {
      const selected = new Date(date);

      const start = new Date(this.guidance.start_date);
      const end = new Date(this.guidance.end_date);

      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 999);

      return selected < start || selected > end;
    },
    hasWorkDetails: function () {
      return this.guidance.workItems.length > 0 &&
          this.guidance.workItems[0] &&
          this.guidance.workItems[0].workItemDetails &&
          this.guidance.workItems[0].workItemDetails.length > 0;
    },
    getProgressStepClass: function (stepName) {
      if (this.isStatusCompleted(stepName)) return 'completed';
      if (this.guidance.status === stepName) return 'active';
      return 'pending';
    },
    getStatusDate: function (statusName) {
      if (!this.guidance.statuses) return null;
      var status = this.guidance.statuses.find(function (s) {
        return s.name === statusName;
      });
      return status ? status.created_at : null;
    },
    canShowStatusButton: function (status, index) {
      if (index === 0) {
        return this.can('create-guidance-status') &&
            this.hasWorkDetails &&
            (this.guidance.status === '' || this.guidance.status === 'Rejected' || this.guidance.status === 'New');
      }
      var prevStatus = this.guidance.possibles[index - 1];
      console.log(status.action.toLowerCase());
      console.log("Angalia hapa");
      return this.can(status.action.toLowerCase() + '-guidance-status') &&
          this.hasWorkDetails &&
          this.guidance.status === (prevStatus ? prevStatus.name : null);
    },
    userModelType: function () {
      return this.me ? this.me.model_type : null;
    },
    canReject: function () {
      if (this.userModelType() === 'Employee') {
        return (
            (this.can('reject-guidance-status') &&
            (this.guidance.works || []).length === 0)
            || (this.can("delete-guidance-status") && this.guidance.status === 'Accepted')
        )
      }

      return (
          this.can('reject-guidance-status') &&
          this.guidance.status !== '' &&
          this.guidance.status !== 'Rejected' &&
          this.guidance.status !== 'Approved' &&
          this.guidance.status !== 'Accepted'
      ) || (
          this.roles.includes('Administrative Officer-PAM') &&
          this.guidance.status !== 'Accepted' &&
          this.guidance.status !== ''
      ) || (this.can("delete-guidance-status") && this.guidance.status === 'Accepted');
    },
    canListStatus: function () {
      return this.can('list-guidance-status');
    },

    getSelectedAction: function () {
      return this.selectedStatus ? this.selectedStatus.action : (this.reject ? 'Reject' : 'Submit');
    },
    showStatusModal: function (status) {
      this.selectedStatus = status;
      this.reject = false;
      this.status.name = status.name;
      this.modal.classicModal = true;
    },
    showRejectModal: function () {
      this.selectedStatus = null;
      this.reject = true;
      this.modal.classicModal = true;
    },
    async updateStatus() {
      try {
        var guidanceData = {
          type: 'guidances',
          id: this.guidance.id,
          status: {
            name: this.status.name,
            reason: this.status.reason,
            reject: this.reject
          },
        };
        await this.$store.dispatch('guidances/update1', guidanceData);
        await this.$store.dispatch('alerts/success', 'Guidance updated successfully.');
        this.classicModalHide();
        await this.$store.dispatch(
            'notifications/pending'
        );

        this.getGuidance();
        //this.$router.go();
      } catch (e) {
        if (e.response && e.response.data && e.response.data.errors && e.response.data.errors[0]) {
          await this.$store.dispatch('alerts/error', e.response.data.errors[0].detail);
          this.setApiValidation(e.response.data.errors);
        } else {
          this.notifyException(e);
        }
      }
    },
    classicModalHide: function () {
      this.modal.classicModal = false;
      this.reject = false;
      this.selectedStatus = null;
      this.status.reason = null;
    },
    creatorLabel: function (status) {
      if (!status) return '';
      var creator = status.creator;
      if (!creator) return status.creator_id || '';
      var model = creator.model;
      if (model) {
        var firstName = typeof model.first_name === 'string' ? model.first_name.trim() : '';
        var lastName = typeof model.last_name === 'string' ? model.last_name.trim() : '';
        var checkNo = model.check_no ? '<br>(C/N: ' + model.check_no + ')' : '';
        var fullName = [firstName, lastName].filter(Boolean).join(' ');
        if (fullName) return fullName + checkNo;
        if (checkNo) return 'Unknown User' + checkNo;
        return creator.name || 'Unknown User';
      }
      return creator.name || 'Unknown User';
    },

    payUnit() {
      const paycode = this.guidance.pay_code;
      if(paycode==='PT'){
        return 'Tonnage';
      }else if(paycode==='PU'){
        return 'Quantity';
      }else if(paycode==='TU'){
        return 'TEUs';
      }else{
        return paycode;
      }
    },

    rateWeekday(workItem) {
      return Number(workItem?.activityTariff?.amount || 0);
    },

    rateWeekend(workItem) {
      return Number(workItem?.activityTariff?.weekend_amount || 0);
    },
    overallWorkItemsTotal() {
      return (this.guidance?.workItems || []).reduce(
          (total, workItem) => total + this.workItemTotal(workItem),
          0
      );
    },
    workTotal(work) {
      return (work?.items|| []).reduce(
          (total, workItem) => total + this.workItemTotal(workItem),
          0
      );
    },
    workItemTotal(workItem) {
      if (!workItem?.workDetails?.length) {
        return 0;
      }

      return workItem.workDetails.reduce((total, detail) => {
        return total + this.lineTotal(detail, workItem);
      }, 0);
    },
    lineTotal(detail, workItem) {
      const quantity = Number(this.workDetailQty(detail) || 0);

      if (!workItem?.activityTariff) {
        return 0;
      }

      // Public Holiday
      if (this.isPublicHoliday(detail.date)) {
        return quantity * Number(
            workItem.activityTariff.weekend_amount || 0
        );
      }

      const day = new Date(detail.date).getDay();

      // Weekend (Saturday = 6, Sunday = 0)
      if (day === 0 || day === 6) {
        return quantity * Number(
            workItem.activityTariff.weekend_amount || 0
        );
      }

      // Weekday
      return quantity * Number(
          workItem.activityTariff.amount || 0
      );
    },

    overallWorkItemsQty() {
      return (this.guidance?.workItems || []).reduce(
          (total, workItem) => total + this.workItemQty(workItem),
          0
      );
    },

    workQty(work) {
      if (!work?.items?.length) {
        return 0;
      }

      return work.items.reduce(
          (total, item) => total + this.workItemQty(item),
          0
      );
    },

    workItemQty(workItem) {

      if (!workItem?.workDetails?.length) {
        return 0;
      }

      return workItem.workDetails.reduce((total, detail) => {
        const quantity = parseFloat(detail.quantity);
        const factor = parseFloat(detail.conversion_factor);

        if (!Number.isFinite(quantity) || !Number.isFinite(factor) || factor <= 0) {
          return total;
        }

        return total + (quantity / factor);
      }, 0);
    },

    totalSubItems(workItem) {
      if (!workItem?.workDetails?.length) {
        return 0;
      }

      return workItem.workDetails.length;
    },
    workDetailQty(detail) {
      const factor = Number(detail.conversion_factor) || 1;
      const quantity = Number(detail.quantity) || 0;

      return this.formatNumber(quantity / factor);
    },

    async publicHolidays() {
      try {
        await this.$store.dispatch('holidays/list');

        this.holidays = this.$store.getters['holidays/list'] || [];

        console.log(this.holidays);
        return this.holidays;

      } catch (error) {
        console.error('Failed to load public holidays:', error);

        this.holidays = [];

        return [];
      }
    },

/*    isPublicHoliday(date) {
      const workDate = new Date(date).toISOString().split('T')[0];

      return this.holidays.some(holiday => {
        const holidayDate = new Date(holiday.holiday_date)
            .toISOString()
            .split('T')[0];

        return holidayDate === workDate;
      });
    },
*/
 isPublicHoliday(date) {
      const formatDate = value => {
        const d = new Date(value);

        const parts = new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Africa/Dar_es_Salaam',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        }).formatToParts(d);

        const get = type => parts.find(p => p.type === type).value;

        return {
          year: get('year'),
          month: get('month'),
          day: get('day')
        };
      };

      const workDate = formatDate(date);


      return this.holidays.some(holiday => {
        const holidayDate = formatDate(holiday.holiday_date);

        if (holiday.repeat === true || holiday.repeat === 1) {
          // Repeating holiday: compare month and day
          return (
              holidayDate.month === workDate.month &&
              holidayDate.day === workDate.day
          );
        }

        // Non-repeating holiday: compare full date
        return (
            holidayDate.year === workDate.year &&
            holidayDate.month === workDate.month &&
            holidayDate.day === workDate.day
        );
      });
    },

    initWorkItemDetails() {
      this.guidance.workItems.forEach(item => {
        this.$set(this.workItemDetails, item.id, {
          item_number: '',
          date: null,
          shift_id: null,
          commodity: '',
          item_type: '',
          quantity: null,
          remarks: ''
        });
      });
    },
    initialize: async function() {
      var self = this;
      self.isLoading = true;
      try {
        await self.getGuidance();
        await self.getWorkplaces();
        await self.getVessels();
        await self.getShifts();
      } catch (error) {
console.log(error);
console.log("page data")
        self.notifyError('Failed to load page data');
      } finally {
        self.isLoading = false;
      }
    },

    getPortName: function() {
      return this.guidance.port ? this.guidance.port.name : '';
    },

    getDepartmentName: function() {
      return this.guidance.department ? this.guidance.department.name : '';
    },

    getVendorName: function() {
      return this.guidance.vendor ? this.guidance.vendor.name : '';
    },

    getTariffName: function() {
      const works = this.guidance.works || [];

      for (const work of works) {
        const items = work.items || [];

        for (const item of items) {
          if (item.activityTariff?.tariff_name) {
            return item.activityTariff.tariff_name;
          }
        }
      }

      return '';
    },
    goBack: function () {
      this.$router.push({name: 'Guidances List'});
    },
    actionPage: function () {
      this.$router.push({name: 'Action Guidance Work Item'});
    },

    getGuidance: async function() {
      var self = this;
      var id = this.$route.params.id;
      this.id = id;

      var params = {
        id: id,
        include: 'port,department,tariff,' +
            'guidanceWorkplaces.workplace.activities,' +
            'workItems.workplace,workItems.activity,' +
            'workItems.activityTariff,' +
            'workItems.workDetails,' +
            'works,' +
            'works.items,' +
            'works.items.activityTariff,' +
            'works.items.activity,' +
            'works.items.workplace,' +
            'works.items.workDetails,' +
            'works.items.workDetails.shift,' +
            'works.vessel,' +
            'workItems.workDetails.shift,' +
            'guidanceWorkplaces.activityGuidances.activity,' +
            'guidanceWorkplaces.activityGuidances.exceptions,' +
            'guidanceWorkplaces.activityGuidances.activityShifts.shift,' +
            'guidanceWorkplaces.activityGuidances.activityTariff,' +
            'guidanceWorkplaces.activityGuidances.exceptions.activity,' +
            'guidanceWorkplaces.activityGuidances.exceptions.activityShifts.shift'
      };

      await this.$store.dispatch('guidances/view', params);
	const guidance = this.$store.getters['guidances/guidance'];
	const paramsPossible = {
        sort: 'order',
        filter: {
          model: 'Guidance',
          is_active: 1,
        },
      };

      await this.$store.dispatch('statusOptions/list', paramsPossible).then(() => {
        guidance.possibles = this.$store.getters['statusOptions/list'];

      });
      this.guidance=guidance;

      console.log(this.guidance);
      console.log("========");
     // this.guidance = this.$store.getters['guidances/guidance'];
      // Convert database 1/0 to boolean
      this.guidance.allow_manual =
          Boolean(Number(this.guidance.allow_manual))

      this.initWorkItemDetails();

    },

    getWorkplaces: async function () {
      console.log('guidance:', this.guidance);
      console.log('vendor_id:', this.guidance && this.guidance.vendor.d);
      const paycode=this.guidance?.pay_code;
      await this.$store.dispatch('workplaces/list', {
        include: 'activities',
        filter: {
          pay_codes: paycode,
          vendor: this.guidance.vendor.id
        }
      });
      this.allWorkplaces = this.$store.getters['workplaces/list'] || [];
      console.log('allWorkplaces:', this.allWorkplaces);
    },

    getVessels: async function() {
      await this.$store.dispatch('vessels/list');
      this.vessels = this.$store.getters['vessels/list'] || [];
    },

    getShifts: async function() {
      var self = this;
      await this.$store.dispatch('shifts/list',{filter:{is_active:'1'}});
      this.shifts = this.$store.getters['shifts/list'] || [];

      var shiftParams = { filter: { guidance: this.id } };
      await this.$store.dispatch('shifts/list', shiftParams);
      this.selected_shifts = this.$store.getters['shifts/list'] || [];
      this.backup_shifts = JSON.parse(JSON.stringify(this.selected_shifts));

      // Ensure all activities have shifts for selected shifts
      this.workPoints.forEach(function(wp) {
        wp.activities.forEach(function(activity) {
          self.ensureActivityShifts(activity);
        });
      });
    },


    ensureActivityShifts: function(activity) {
      var self = this;
      if (!activity.activity_shifts) {
        activity.activity_shifts = [];
      }

      this.selected_shifts.forEach(function(shift) {
        // Check by shift.id (UUID) instead of shift_id
        var existing = activity.activity_shifts.find(function(s) {
          return s.shift && s.shift.id === shift.id;
        });

        if (!existing) {
          activity.activity_shifts.push({
            shift_id: shift.id,
            shift: shift,
            labourer_count: 0,
            request_type: 'Open',
            day_type: activity.day_type || 'Weekday'
          });
        }
      });
    },

    removeActivity: async function(wpIndex, actIndex) {
      var self = this;
      var result = await Swal.fire({
        title: 'Remove Activity?',
        text: 'Are you sure you want to remove this activity?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, remove',
        cancelButtonText: 'Cancel'
      });

      if (!result.value) return;

      var activity = this.workPoints[wpIndex].activities[actIndex];

      try {
        if (activity.id) {
          await this.$store.dispatch('activityGuidances/destroy', activity.id);
        }

        this.workPoints[wpIndex].activities.splice(actIndex, 1);
        this.notifySuccess('Activity removed successfully');
        this.updateAllTotals();
      } catch (error) {
        this.notifyError('Error removing activity:', error);
        this.handleApiError(error);
      }
    },


    handleApiError: function(error) {
      if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.length) {
        var apiError = error.response.data.errors[0];
        this.notifyError(apiError.title || apiError.detail || 'An error occurred');
        this.setApiValidation(error.response.data.errors);
      } else {
        this.notifyError('An unexpected error occurred. Please try again.');
      }
    },


    formatCurrency: function(amount) {
      if (amount === undefined || amount === null) return 'TZS 0';
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'TZS',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(amount);
    },

    formatNumber: function(number) {
      if (number === undefined || number === null) return '0';
      return new Intl.NumberFormat('en-US').format(number);
    },

    goToEdit(id) {
      this.$router.push({name: 'Edit Guidance', params: {id}});
    },


    // Status helpers
    isStatusCompleted: function (statusName) {
      if (!this.guidance.statuses) return false;
      return this.guidance.statuses.some(function (s) {
        return s.name === statusName;
      });
    },
    formatDateShort: function (dateString) {
      if (!dateString) return '';
      return new Date(dateString).toLocaleDateString();
    },

    async saveAllowManual() {
      const previousValue = !this.guidance.allow_manual;
      try {
        this.isLoading = true;

        const response = await this.$store.dispatch(
            'guidances/updateAllowManual',
            {
              id: this.guidance.id,
              allow_manual: this.guidance.allow_manual
            }
        );

        await this.$store.dispatch(
            'alerts/success',
            response.message
        );

      } catch (e) {
        // Restore switch to previous state
        this.guidance.allow_manual = previousValue;

        console.log('Allow Manual Error:', e);
        console.log('Response:', e.response?.data);

        const message =
            e.response?.data?.message ||
            e.response?.data?.errors?.[0]?.detail ||
            'Unable to update manual entry setting.';

        await this.$store.dispatch(
            'alerts/error',
            message
        );
      } finally {
        this.isLoading = false;
        this.getGuidance();

      }
    }
  }
};
</script>

<style scoped>
.section-label {
  display: block;
  font-weight: 600;
  margin-bottom: 8px;
  color: #333;
  font-size: 14px;
}

.help-text {
  font-size: 12px;
  color: #666;
  margin-top: 4px;
}

.action-bar, .action-bar-bottom {
  display: flex;
  gap: 10px;
  margin: 15px;
  justify-content: flex-end;
}

.workpoint-card {
  margin: 15px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
}

.workpoint-card-content {
  padding: 0;
}

.workpoint-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
}

.workpoint-header h4 {
  margin: 0;
  color: #333;
}

.activities-section {
  padding: 15px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.warning-box {
  background: #fff3e0;
  border-left: 4px solid #ff9800;
  padding: 12px;
  margin-bottom: 15px;
  color: #e65100;
  font-size: 14px;
}

.empty-activities {
  text-align: center;
  padding: 40px;
  color: #999;
}

.empty-activities md-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  margin-bottom: 10px;
}

.shift-input-container {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 100px;
}

.shift-field {
  margin: 0;
  padding: 0;
  flex: 1;
}

.shift-field .md-input {
  font-size: 14px;
  padding: 8px;
  text-align: center;
}

.provision-checkbox {
  margin: 0 !important;
  transform: scale(0.8);
}

.action-buttons {
  display: flex;
  gap: 5px;
  align-items: center;
  flex-wrap: wrap;
}

.saved-badge {
  font-size: 11px;
  color: #4caf50;
  background: #e8f5e9;
  padding: 2px 6px;
  border-radius: 4px;
}

.shift-time {
  display: block;
  font-size: 10px;
  color: #666;
  font-weight: normal;
}

.table-footer-row {
  background-color: #f5f5f5;
  font-weight: bold;
}

.cell-50 {
  min-width: 250px;
}

.cell-10 {
  min-width: 100px;
}

.md-button.md-small {
  height: 32px;
  min-height: 32px;
  font-size: 12px;
  padding: 0 12px;
}

.md-button.md-small .md-icon {
  font-size: 18px;
  line-height: 18px;
}

.mt-4 {
  margin-top: 16px;
}

.exception-count {
  position: absolute;
  top: -5px;
  right: -5px;
  background-color: #ff9800;
  color: white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

.md-button {
  position: relative;
}

.md-button.md-danger .exception-count {
  background-color: #fff;
  color: #f44336;
}
.full-width-item {
  width: 100%;
  max-width: 100%;
}

.full-width-container {
  width: 100%;
}

.full-width-table {
  width: 100% !important;
  table-layout: fixed; /* important for full stretch */
}

.md-card-content {
  width: 100%;
}
.form-container {
  padding: 15px;
  border: 1px solid #eee;
  border-radius: 8px;
  background: #fafafa;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-5px);
}
.work-item-card {
  margin-bottom: 20px;
  border-radius: 12px;
}

.card-header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-total {
  font-size: 18px;
  font-weight: bold;
  color: #1976d2;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

@media (max-width: 768px) {
  .summary-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
.md-card {
  border-radius: 10px;
}

.md-card-header {
  background: #f5f7fa;
  border-bottom: 1px solid #eee;
}

.md-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.md-field {
  margin-top: 12px;
}

.multiselect {
  min-height: 48px;
}

.md-caption {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
  font-weight: 600;
}
.ticket-preview {
  border: 1px solid #ddd;
  border-radius: 6px;
  background: #fff;
  overflow: hidden;
  margin-top: 15px;
}

.ticket-preview-header {
  padding: 15px 20px;
  border-bottom: 1px solid #ddd;
  background: #fafafa;
}

.ticket-preview-header h3 {
  margin: 0;
  font-size: 18px;
}

.ticket-preview-body {
  padding: 20px;
}

.preview-section {
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  padding: 15px;
  margin-bottom: 15px;
}

.preview-field {
  padding: 8px 15px;
}

.preview-value {
  margin-top: 5px;
  font-size: 15px;
  color: #333;
}
.form-details-card {
  background: #ffffff;
  border: 1px solid #cfd8e3;
  border-radius: 10px;
  padding: 20px 24px;
  margin: 15px 0 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

  color: #212529;
}

.form-details-card label,
.form-details-card strong,
.form-details-card p,
.form-details-card span {
  color: #212529;
}

.form-details-card small,
.form-details-card .text-muted {
  color: #6c757d !important;
}

.form-details-card .md-field {
  background: #ffffff;
}

.form-details-card input,
.form-details-card textarea {
  color: #212529 !important;
}
.form-hint {
  display: block;
  margin-bottom: 6px;
  color: #008800 !important;
  font-weight: 500;
}
.ticket-preview-dialog {
  width: 90%;
  max-width: 1200px;
}

.ticket-preview {
  padding: 5px 10px;
}

.preview-section {
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
}

.preview-section-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.preview-field {
  margin-bottom: 15px;
}

.preview-value {
  margin-top: 4px;
  font-size: 15px;
  font-weight: 500;
}

.md-dialog-content {
  max-height: 75vh;
}

/* =========================================================
   WORKS / VESSEL / ITEMS TABLE
   ========================================================= */

.works-container {
  width: 100%;
}


/* ---------------------------------------------------------
   WORK CARD
   --------------------------------------------------------- */

.work-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  margin-bottom: 20px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}


/* ---------------------------------------------------------
   WORK HEADER
   --------------------------------------------------------- */

.work-header {
  padding: 16px 20px;
  background: #f8f9fa;
  border-bottom: 1px solid #e5e7eb;

  display: flex;
  justify-content: space-between;
  align-items: center;
}

.work-title {
  display: flex;
  align-items: center;
  gap: 10px;

  font-size: 16px;
  font-weight: 600;
}

.work-number {
  color: #343a40;
}


/* ---------------------------------------------------------
   WORK INFORMATION
   --------------------------------------------------------- */

.work-information {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;

  margin-top: 8px;

  font-size: 15px;
  font-weight: bold;
  color: #1976d2;;
}

.work-information span {
  display: inline-flex;
  align-items: center;
}

.work-information .md-icon {
  font-size: 17px !important;
  min-width: 18px;
  width: 18px;
  margin-right: 5px;
}


/* ---------------------------------------------------------
   ITEMS TABLE
   --------------------------------------------------------- */

.items-table {
  margin: 0;
  width: 100%;
}

.items-table thead th {
  background: #ffffff;
  border-top: 0;
  border-bottom: 1px solid #dee2e6;

  color: #6c757d;

  font-size: 13px;
  font-weight: 600;

  text-transform: uppercase;
  letter-spacing: .04em;

  padding: 12px 14px;
  white-space: nowrap;
}

.items-table tbody td {
  padding: 13px 14px;
  vertical-align: middle;

  border-top: 1px solid #f0f0f0;

  font-size: 15px;
}


/* ---------------------------------------------------------
   ITEM ROW
   --------------------------------------------------------- */

.item-row {
  cursor: pointer;
  transition: background-color .15s ease;
}

.item-row:hover {
  background: #f8f9fa;
}

.item-row > td:first-child {
  width: 45px;
  text-align: center;
}

.item-row .md-icon {
  font-size: 20px !important;
}


/* ---------------------------------------------------------
   ITEM NUMBER
   --------------------------------------------------------- */

.item-row td:nth-child(2) strong {
  font-weight: 600;
  color: #343a40;
}


/* ---------------------------------------------------------
   STATUS
   --------------------------------------------------------- */

.status-badge {
  display: inline-flex;
  align-items: center;

  padding: 4px 10px;

  border-radius: 20px;

  font-size: 11px;
  font-weight: 600;

  white-space: nowrap;
}

.status-success {
  background: #e8f5e9;
  color: #2e7d32;
}

.status-warning {
  background: #fff8e1;
  color: #ef6c00;
}

.status-danger {
  background: #ffebee;
  color: #c62828;
}

.status-primary {
  background: #e3f2fd;
  color: #1565c0;
}
.status-info {
  background: #e0f7fa;
  color: #00838f;
}
.status-purple {
  background: #f3e5f5;
  color: #7b1fa2;
}
.status-accepted {
  background: #e0f2f1;
  color: #00695c;
}
.status-default {
  background: #eceff1;
  color: #546e7a;
}


/* ---------------------------------------------------------
   WORK DETAILS ROW
   --------------------------------------------------------- */

.details-row {
  background: #f8f9fa;
}

.details-row > td {
  padding: 0 !important;
  border-top: 0 !important;
}

.details-container {
  padding: 18px 25px 20px 65px;
}


/* ---------------------------------------------------------
   DETAILS TITLE
   --------------------------------------------------------- */

.details-title {
  display: flex;
  align-items: center;

  margin-bottom: 12px;

  font-size: 13px;
  font-weight: 600;

  color: #495057;
}

.details-title .md-icon {
  font-size: 18px !important;
  margin-right: 6px;
}


/* ---------------------------------------------------------
   DETAILS TABLE
   --------------------------------------------------------- */

.details-table {
  width: 100%;
  margin-bottom: 0;

  background: #ffffff;

  border: 1px solid #e2e5e8;
}

.details-table thead th {
  background: #f8f9fa;

  border-top: 0;
  border-bottom: 1px solid #dee2e6;

  color: #6c757d;

  font-size: 10px;
  font-weight: 600;

  text-transform: uppercase;

  padding: 9px 12px;
}

.details-table tbody td {
  padding: 9px 12px;

  font-size: 12px;

  border-top: 1px solid #f0f0f0;
}


/* ---------------------------------------------------------
   WORK COUNT
   --------------------------------------------------------- */

.work-count {
  display: inline-flex;
  align-items: center;

  padding: 5px 12px;

  border-radius: 20px;

  background: #eef1f4;

  color: #495057;

  font-size: 11px;
  font-weight: 600;
}


/* ---------------------------------------------------------
   RESPONSIVE
   --------------------------------------------------------- */

@media (max-width: 992px) {

  .work-header {
    align-items: flex-start;
  }

  .work-information {
    gap: 10px 15px;
  }

  .details-container {
    padding-left: 25px;
  }

}


@media (max-width: 768px) {

  .work-header {
    flex-direction: column;
    gap: 12px;
  }

  .work-information {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }

  .items-table {
    min-width: 900px;
  }

  .details-table {
    min-width: 600px;
  }

}
.action-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.vessel-select-wrapper {
  display: flex;
  align-items: flex-start;
  width: 100%;
  gap: 10px;
}

.vessel-select {
  flex: 1;
  min-width: 0;
}

.add-vessel-btn {
  margin: 0 !important;
  white-space: nowrap;
  height: 40px;
}
.vessel-badge {
  display: inline-flex;
  align-items: center;
  gap: 7px;

  padding: 6px 12px;

  background: #eef4ff;
  color: #2457c5;

  border: 1px solid #cddcff;
  border-radius: 18px;

  font-size: 13px;
  font-weight: 600;

  white-space: nowrap;
}

.vessel-badge .md-icon {
  font-size: 18px !important;
  width: 18px;
  min-width: 18px;

  color: #f5a900 !important;
}
.action-buttons-vertical {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.action-workflow-btn {
  width: 100%;
  min-height: 42px;
  margin: 0 !important;
  border-radius: 6px !important;

  display: flex !important;
  align-items: center;
  justify-content: center;

  font-weight: 500;
  text-transform: none !important;

  transition: all 0.2s ease-in-out;

  .md-icon {
    margin-right: 8px;
    font-size: 19px !important;
    color: #fff !important;
  }

  &:hover {
    transform: translateY(-1px);
  }
}

/* Status transition buttons */
.action-status {
  background: #1976d2 !important;
  color: #fff !important;

  &:hover {
    background: #1565c0 !important;
    box-shadow: 0 4px 10px rgba(25, 118, 210, 0.3) !important;
  }
}

/* Reject */
.action-reject {
  background: #e53935 !important;
  color: #fff !important;

  &:hover {
    background: #c62828 !important;
    box-shadow: 0 4px 10px rgba(229, 57, 53, 0.3) !important;
  }
}

/* Action page */
.action-page {
  background: #00897b !important;
  color: #fff !important;

  &:hover {
    background: #00695c !important;
    box-shadow: 0 4px 10px rgba(0, 137, 123, 0.3) !important;
  }
}
.action-park {
  background: #2196f3 !important;
}

.action-review {
  background: #9c27b0 !important;
}

.action-certify {
  background: #00bcd4 !important;
}

.action-confirm {
  background: #ff9800 !important;
}

.action-approve {
  background: #4caf50 !important;
}

.action-accept {
  background: #00695c !important;
}


</style>
